var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "employees-card-bottom" }, [
        _c("div", { staticClass: "flex-row flex-col" }, [
          _c(
            "div",
            [
              _c(
                "el-tabs",
                {
                  staticClass: "tabs",
                  on: { "tab-click": _vm.activeClick },
                  model: {
                    value: _vm.activeVal,
                    callback: function ($$v) {
                      _vm.activeVal = $$v
                    },
                    expression: "activeVal",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "我的工作分析", name: "1" },
                  }),
                  _vm._v(" "),
                  _c("el-tab-pane", {
                    attrs: { label: "下级工作分析", name: "2" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeVal == 2
            ? _c("div", { staticClass: "flex pt10" })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "splitLine mb20" }),
        _vm._v(" "),
        _vm.activeVal == 1
          ? _c("div", { staticClass: "main" }, [
              _vm.mineContent
                ? _c("div", { staticClass: "detail-box" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("工作分析")]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "content",
                      domProps: { innerHTML: _vm._s(_vm.mineContent) },
                    }),
                  ])
                : _c(
                    "div",
                    [
                      _c("default-page", {
                        directives: [{ name: "height", rawName: "v-height" }],
                        attrs: { index: 15, "min-height": 580 },
                      }),
                    ],
                    1
                  ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.activeVal == 2
          ? _c(
              "div",
              { staticClass: "table-box" },
              [
                _c(
                  "div",
                  { staticClass: "inTotal" },
                  [
                    _vm._v(
                      "\n        共 " +
                        _vm._s(_vm.totalSubmit) +
                        " 条\n        "
                    ),
                    _c(
                      "el-form",
                      {
                        staticClass: "from-s",
                        attrs: { inline: true },
                        nativeOn: {
                          submit: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { staticClass: "select-bar" },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                placeholder: "请输入姓名搜索",
                                "prefix-icon": "el-icon-search",
                                size: "small",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getList(1)
                                },
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.getList(1)
                                },
                              },
                              model: {
                                value: _vm.where.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.where, "name", $$v)
                                },
                                expression: "where.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { staticClass: "select-bar" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择职位",
                                  size: "small",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.getList(1)
                                  },
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.getList(1)
                                  },
                                },
                                model: {
                                  value: _vm.where.job_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.where, "job_id", $$v)
                                  },
                                  expression: "where.job_id",
                                },
                              },
                              _vm._l(_vm.options, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.tableData, height: _vm.tableHeight },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "index", width: "50", label: "序号" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "人员姓名", prop: "name" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "职位", prop: "job.name" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "部门", prop: "frame.name" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "更新时间", prop: "updated_at" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { fixed: "right", label: "操作", width: "130" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["user:duty:analyse:check"],
                                        expression:
                                          "['user:duty:analyse:check']",
                                      },
                                    ],
                                    attrs: { size: "small", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onCheck(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                ),
                                _vm._v(" "),
                                scope.row.operate
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: ["user:duty:analyse:edit"],
                                            expression:
                                              "['user:duty:analyse:edit']",
                                          },
                                        ],
                                        attrs: { size: "small", type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1106556036
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-fixed" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.where.page,
                        "page-size": _vm.where.limit,
                        "page-sizes": [15, 20, 30],
                        total: _vm.totalSubmit,
                        layout: "total,sizes, prev, pager, next, jumper",
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.checkDrawer,
            direction: "rtl",
            size: "60%",
            title: "工作分析表",
          },
          on: {
            "update:visible": function ($event) {
              _vm.checkDrawer = $event
            },
          },
        },
        [
          _vm.detailData
            ? _c("div", { staticClass: "check-box" }, [
                _c("div", {
                  staticClass: "content mt14",
                  domProps: { innerHTML: _vm._s(_vm.detailData) },
                }),
              ])
            : _c(
                "div",
                [
                  _c("default-page", {
                    directives: [{ name: "height", rawName: "v-height" }],
                    attrs: { index: 14, "min-height": 580 },
                  }),
                ],
                1
              ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.editDrawer,
            wrapperClosable: false,
            direction: "rtl",
            size: "60%",
            title: "编辑工作分析表",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDrawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "check-box" }, [
            _c("div", { staticClass: "user-name" }, [
              _c("span", [_vm._v("人员姓名：")]),
              _vm._v(" "),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.userName)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "boder" },
              [
                _c(_vm.loadEdit, {
                  ref: "ueditorFrom",
                  tag: "component",
                  attrs: {
                    border: true,
                    content: _vm.content,
                    height: _vm.height,
                  },
                  on: { input: _vm.ueditorEdit },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.editDrawer = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loading,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }